import React from 'react';

import { ScreenshotBoundingBox } from '@evinced-private/ui-common';

export const getBoundingBoxStyles = (
	boundingBox: ScreenshotBoundingBox,
	scale: number
): React.CSSProperties => {
	return {
		left: `${boundingBox.x * scale}px`,
		top: `${boundingBox.y * scale}px`,
		width: `${boundingBox.width * scale}px`,
		height: `${boundingBox.height * scale}px`
	};
};
